import {
  put
} from 'redux-saga/effects';
import {
  getToken
} from '../selectors/tokenSelector';
import * as types from 'constants/actionTypes';
import env from 'config/env';

const posSagaUtil = {
  get: (url) => {
    let token = getToken();
    if (process.env.NODE_ENV === 'development') {
      console.log('Request GET, URL:' + url);
    }
    return fetch(url, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        'timezone_offset': new Date(Date.now()).getTimezoneOffset()
      },
      credentials: 'include'
    });
  },
  post: (url, data) => {

    let token = getToken();

    if (process.env.NODE_ENV === 'development') {
      console.log('Request POST, URL:' + url);
      console.log('data: ' + JSON.stringify(data));
      console.log('token: ' + JSON.stringify(token));
    }

    return fetch(url, {
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : null,
        'timezone_offset': new Date(Date.now()).getTimezoneOffset()
      },
      method: "POST",
      body: JSON.stringify(data)
    });
  },
  patch: (url, data) => {

    let token = getToken();

    if (process.env.NODE_ENV === 'development') {
      console.log('Request PATCH, URL:' + url);
      console.log('data: ' + JSON.stringify(data));
      console.log('token: ' + JSON.stringify(token));
    }

    return fetch(url, {
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      method: "PATCH",
      body: JSON.stringify(data)
    });
  },
  fetch: function* (url, data, success, failed, isText = false, message = null, showLoading = true) {
    //show loading icon
    if (showLoading) {
      yield put({
        type: 'LOADING',
        val: 1
      });
    }

    let promise;

    try {
      promise = yield (data ? posSagaUtil.post(env.posAPIUrl() + url, data) : posSagaUtil.get(env.posAPIUrl() + url))
        .then(resp => {
          if (process.env.NODE_ENV === 'development') {
            console.log("RESP ", resp);
            console.log("response status code: " + resp.status);
          }

          //unauthorized
          if (resp.status === 401) {
            return {
              success: false,
              statusCode: resp.status
            };
          }

          return isText ? resp.text() : resp.json();
        });

      if (process.env.NODE_ENV === 'development') {
        console.log("Response for URL:" + url);
        console.log(promise);
      }

      if (promise && promise.success) {
        yield put(success(promise));

        //If there`s a message to be shown after an action
        if (message) {
          yield put({
            type: types.SNACKBAR_SHOW_MESSAGE,
            message: message
          });
        }
      } else {

        if (failed) {
          yield put(failed(promise));
        }
        else {

          yield put({
            type: 'ERROR',
            message: promise && promise.error
          });

        }
        if (promise.statusCode) {

          switch (promise.statusCode) {
            case 401:
              yield put({
                type: types.UNAUTHORIZED_USER
              });
              break;
            default:
              break;
          }

        }
      }
    } catch (e) {
      console.log('API call failed. URL: ' + url);
      console.log('Exception Detail: ' + e);
      yield put({
        type: 'API_EXCEPTION',
        e
      });
      if (failed)
        yield put(failed(promise));
    } finally {
      //hide loading icon
      if (showLoading) {
        yield put({
          type: 'LOADING',
          val: -1
        });
      }
    }
  },
  // This fetch should rely on httpCode and not a property called success returning from the backend.
  // Additionally, this function handles api exceptions sent by API filter.
  newFetch: function* (method, url, data, success, failed, isText = false, message = null, showLoading = true) {
    // Show loading icon
    if (showLoading) {
      yield put({ type: 'LOADING', val: 1 });
    }

    try {
      let resp;

      switch (method) {
        case 'GET':
          resp = yield posSagaUtil.get(env.posAPIUrl() + url);
          break;
        case 'POST':
          resp = yield posSagaUtil.post(env.posAPIUrl() + url, data);
          break;
        case 'PATCH':
          resp = yield posSagaUtil.patch(env.posAPIUrl() + url, data);
          break;
      }

      if (process.env.NODE_ENV === 'development') {
        console.log("RESP ", resp);
        console.log("response status code: " + resp.status);
      }

      let responseData;
      if (resp.ok) {
        responseData = isText ? yield resp.text() : yield resp.json();
        yield put(success(responseData));

        // Show message if available
        if (message) {
          yield put({ type: types.SNACKBAR_SHOW_MESSAGE, message: message });
        }
      } else {
        responseData = yield resp.json();
        yield put({ type: 'API_EXCEPTION', responseData });
        let errorMessage = responseData.errorMessage;
        if (errorMessage)
          yield put({ type: types.SNACKBAR_SHOW_MESSAGE, message: errorMessage });
      }
    } catch (e) {
      console.error('API call failed. URL: ' + url);
      console.error('Exception Detail: ' + e);
      yield put({ type: 'API_EXCEPTION', e });

      if (failed) {
        yield put(failed(e));
      }
    } finally {
      // Hide loading icon
      if (showLoading) {
        yield put({ type: 'LOADING', val: -1 });
      }
    }
  },
  getQueryString: (model) => {
    const queryParams = [];
    for (let key in model) {
      const value = model[key];
      if (value)
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    }
    return queryParams.join('&');
  }
};

export default posSagaUtil;
